// extracted by mini-css-extract-plugin
export default {"container":"Element_container__kV0Gc","title":"Element_title__KONRN","list":"Element_list__3xlBi","LFPManager":"Element_LFPManager__Nvzh6","listItem":"Element_listItem__9Grx8"};